// extracted by mini-css-extract-plugin
export default {"offersList":"SpecialOffersPage_offersList__Hwhrn","noOffersContainer":"SpecialOffersPage_noOffersContainer__qhlVi","noOffersTitle":"SpecialOffersPage_noOffersTitle__x12sB"};